import { ScriptLanguage } from "@/script/model"

// Mirrors Script\Helper::argNames, the authority: the backend rejects edges
// naming anything else. Kept here so handles appear while typing.
const patterns = {
  [ScriptLanguage.JavaScript]: /function\s+execute\s*\(\s*([^)]*)\)/m,
  [ScriptLanguage.Python]: /def\s+execute\s*\(\s*([^)]*)\)/m,
}

const argPatterns = {
  // "$" is a legal identifier character in JS, so it is part of the name.
  [ScriptLanguage.JavaScript]: /^(?:\.\.\.)?([A-Za-z_$][\w$]*)/,
  [ScriptLanguage.Python]: /^\*{0,2}([A-Za-z_]\w*)/,
}

export const argNames = (lang: ScriptLanguage, code: string | undefined) => {
  if (!code) {
    return []
  }
  const m = code.match(patterns[lang])
  const argsStr = m?.[1]
  if (!argsStr?.trim()) {
    return []
  }

  return argsStr
    .split(",")
    .map((a) => a.trim())
    .filter((a) => a)
    .map((arg) => arg.match(argPatterns[lang])?.[1] ?? "")
    .filter(Boolean)
}

export const argsJsonSchema = (
  lang: ScriptLanguage,
  code: string | undefined,
) => {
  const args = argNames(lang, code)

  return JSON.stringify(
    {
      type: "object",
      properties: Object.fromEntries(
        args.map((name) => [name, { type: "string" }]),
      ),
      required: args,
      additionalProperties: false,
    },
    null,
    2,
  )
}
